<p-accordion>
  <p-accordionTab [selected]="openedAccordion">
    <query-builder #qB data-testid="qB" [formControl]="ctrl" [(ngModel)]='query' [config]='config'>
      <!-- Rule Buttons -->
      <ng-container *queryButtonGroup="let ruleset; let addRule=addRule; let addRuleSet=addRuleSet; let removeRuleSet=removeRuleSet">
        <button type="button" class="rule-button" (click)="addRule()">+ {{ 'common.rule' | translate }}</button>
        <button *ngIf="removeRuleSet" type="button" class="rule-button" (click)="removeRuleSet()"><span class="remove-icon"></span></button>
      </ng-container>
      <!-- Condition Buttons -->
      <ng-container *querySwitchGroup="let ruleset; let i = index">
        <div id="ruleset-condition-radio-container">
          <p-radioButton *ngIf="ruleset" class="ruleset-condition-radio" [name]="i" [(ngModel)]="ruleset.condition" label="{{'common.and' | translate}}" value="and"></p-radioButton>
          <p-radioButton *ngIf="ruleset" class="ruleset-condition-radio" [name]="i" [(ngModel)]="ruleset.condition" label="{{'common.or' | translate}}" value="or"></p-radioButton>
        </div>
      </ng-container>
      <!-- Text Input -->
      <ng-container *queryInput="let rule; let field=field; type: 'string'">
        <input *ngIf="controlOperator(rule.operator)" type="text" [(ngModel)]="rule.value" style="height: 32px;" [maxlength]="field.maxLength">
      </ng-container>
      <!-- Date Input -->
   
    </query-builder>
    <p class="input-error-notification" *ngIf="ctrl.invalid && submitted">{{ 'common.allFieldsRequired' | translate }}</p>
    <div style="text-align: right; width: 100%; margin-top: 15px;">
      <button
        pButton
        *ngIf="showSendQueryBtn"
        type="button"
        class="k-generic-btn"
        label="{{ 'common.startSearch' | translate }}"
        (click)="sendQuery()"
      ></button>
    </div>
  </p-accordionTab>
</p-accordion>



// WEBPACK FOOTER //
// ./src/app/modules/UIKit/components/rules-query-builder/rules-query-builder.component.html